/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGuildDto } from '../models/custom-result-of-guild-dto';
import { CustomResultOfIListOfSimpleListDto } from '../models/custom-result-of-i-list-of-simple-list-dto';
import { CustomResultOfListOfSimpleListDto } from '../models/custom-result-of-list-of-simple-list-dto';
import { CustomResultOfPaginatedListOfGuildWithPaginationDto } from '../models/custom-result-of-paginated-list-of-guild-with-pagination-dto';
import { guildsCreateGet } from '../fn/guilds/guilds-create-get';
import { GuildsCreateGet$Params } from '../fn/guilds/guilds-create-get';
import { guildsCreatePost } from '../fn/guilds/guilds-create-post';
import { GuildsCreatePost$Params } from '../fn/guilds/guilds-create-post';
import { guildsDelete } from '../fn/guilds/guilds-delete';
import { GuildsDelete$Params } from '../fn/guilds/guilds-delete';
import { guildsGetGuilds } from '../fn/guilds/guilds-get-guilds';
import { GuildsGetGuilds$Params } from '../fn/guilds/guilds-get-guilds';
import { guildsGetGuildsAudit } from '../fn/guilds/guilds-get-guilds-audit';
import { GuildsGetGuildsAudit$Params } from '../fn/guilds/guilds-get-guilds-audit';
import { guildsGetGuildsByParentIdList } from '../fn/guilds/guilds-get-guilds-by-parent-id-list';
import { GuildsGetGuildsByParentIdList$Params } from '../fn/guilds/guilds-get-guilds-by-parent-id-list';
import { guildsGetGuildsWithPagination } from '../fn/guilds/guilds-get-guilds-with-pagination';
import { GuildsGetGuildsWithPagination$Params } from '../fn/guilds/guilds-get-guilds-with-pagination';
import { guildsUpdateGet } from '../fn/guilds/guilds-update-get';
import { GuildsUpdateGet$Params } from '../fn/guilds/guilds-update-get';
import { guildsUpdatePut } from '../fn/guilds/guilds-update-put';
import { GuildsUpdatePut$Params } from '../fn/guilds/guilds-update-put';

@Injectable({ providedIn: 'root' })
export class GuildsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `guildsGetGuildsAudit()` */
  static readonly GuildsGetGuildsAuditPath = '/Guilds/GetGuildsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsGetGuildsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsGetGuildsAudit$Response(params: GuildsGetGuildsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return guildsGetGuildsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsGetGuildsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsGetGuildsAudit(params: GuildsGetGuildsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.guildsGetGuildsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `guildsGetGuildsWithPagination()` */
  static readonly GuildsGetGuildsWithPaginationPath = '/Guilds/GetGuildsWithPagination';

  /**
   * Get Guilds with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsGetGuildsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsGetGuildsWithPagination$Response(params: GuildsGetGuildsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGuildWithPaginationDto>> {
    return guildsGetGuildsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Guilds with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsGetGuildsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsGetGuildsWithPagination(params: GuildsGetGuildsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGuildWithPaginationDto> {
    return this.guildsGetGuildsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGuildWithPaginationDto>): CustomResultOfPaginatedListOfGuildWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `guildsGetGuildsByParentIdList()` */
  static readonly GuildsGetGuildsByParentIdListPath = '/Guilds/GetGuildsByParentIdList';

  /**
   * Get list of Guilds by ParentId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsGetGuildsByParentIdList()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsGetGuildsByParentIdList$Response(params?: GuildsGetGuildsByParentIdList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSimpleListDto>> {
    return guildsGetGuildsByParentIdList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of Guilds by ParentId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsGetGuildsByParentIdList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsGetGuildsByParentIdList(params?: GuildsGetGuildsByParentIdList$Params, context?: HttpContext): Observable<CustomResultOfListOfSimpleListDto> {
    return this.guildsGetGuildsByParentIdList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSimpleListDto>): CustomResultOfListOfSimpleListDto => r.body)
    );
  }

  /** Path part for operation `guildsCreateGet()` */
  static readonly GuildsCreateGetPath = '/Guilds/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsCreateGet$Response(params?: GuildsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return guildsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsCreateGet(params?: GuildsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.guildsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `guildsCreatePost()` */
  static readonly GuildsCreatePostPath = '/Guilds/Create';

  /**
   * Create Guild.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsCreatePost$Response(params: GuildsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return guildsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Guild.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsCreatePost(params: GuildsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.guildsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `guildsUpdateGet()` */
  static readonly GuildsUpdateGetPath = '/Guilds/Update';

  /**
   * Get Guild by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsUpdateGet$Response(params?: GuildsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGuildDto>> {
    return guildsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Guild by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsUpdateGet(params?: GuildsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGuildDto> {
    return this.guildsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGuildDto>): CustomResultOfGuildDto => r.body)
    );
  }

  /** Path part for operation `guildsUpdatePut()` */
  static readonly GuildsUpdatePutPath = '/Guilds/Update';

  /**
   * Update Guild.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsUpdatePut$Response(params: GuildsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return guildsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Guild.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  guildsUpdatePut(params: GuildsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.guildsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `guildsDelete()` */
  static readonly GuildsDeletePath = '/Guilds/Delete';

  /**
   * Delete Guild.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsDelete$Response(params?: GuildsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return guildsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Guild.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsDelete(params?: GuildsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.guildsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `guildsGetGuilds()` */
  static readonly GuildsGetGuildsPath = '/Guilds/GetGuilds';

  /**
   * Get Guild For dropdown.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `guildsGetGuilds()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsGetGuilds$Response(params?: GuildsGetGuilds$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfIListOfSimpleListDto>> {
    return guildsGetGuilds(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Guild For dropdown.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `guildsGetGuilds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  guildsGetGuilds(params?: GuildsGetGuilds$Params, context?: HttpContext): Observable<CustomResultOfIListOfSimpleListDto> {
    return this.guildsGetGuilds$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfIListOfSimpleListDto>): CustomResultOfIListOfSimpleListDto => r.body)
    );
  }

}
